var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareGuestCampaignImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 530 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_21-2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#_\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_21-5);\n      }\n\n      .cls-3 {\n        fill: url(#_\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_21-3);\n      }\n\n      .cls-4 {\n        fill: url(#_\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_21-4);\n      }\n\n      .cls-5, .cls-8, .cls-9, .cls-10, .cls-11, .cls-34, .cls-35 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-5, .cls-47 {\n        fill: #f8ead6;\n      }\n\n      .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: url(#_\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_21);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-8, .cls-9, .cls-10, .cls-11 {\n        opacity: .6;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-13 {\n        fill: url(#_\u30DB\u30EF\u30A4\u30C8_\u30D6\u30E9\u30C3\u30AF);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-80 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-81 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-20);\n        opacity: .32;\n      }\n\n      .cls-82 {\n        opacity: .3;\n      }\n\n      .cls-35 {\n        fill: #1a1a1a;\n        opacity: .5;\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-83 {\n        isolation: isolate;\n      }\n\n      .cls-45 {\n        fill: #f9aa9a;\n      }\n\n      .cls-46 {\n        fill: #fab6ae;\n      }\n\n      .cls-48 {\n        fill: #536096;\n      }\n\n      .cls-49 {\n        fill: #754c24;\n      }\n\n      .cls-50 {\n        fill: #4d4d4d;\n      }\n\n      .cls-51 {\n        fill: #557689;\n      }\n\n      .cls-52 {\n        fill: gray;\n      }\n\n      .cls-53 {\n        fill: #455484;\n      }\n\n      .cls-54 {\n        fill: #71a0ba;\n      }\n\n      .cls-55 {\n        fill: #3d3535;\n      }\n\n      .cls-56 {\n        fill: #84655f;\n      }\n\n      .cls-57 {\n        fill: #424242;\n      }\n\n      .cls-58 {\n        fill: #434556;\n      }\n\n      .cls-59 {\n        fill: #1e1e1e;\n      }\n\n      .cls-60 {\n        fill: #da6753;\n      }\n\n      .cls-61 {\n        fill: #e0eff7;\n      }\n\n      .cls-62 {\n        fill: #dd563f;\n      }\n\n      .cls-63 {\n        fill: #aa817b;\n      }\n\n      .cls-64 {\n        fill: #c0e0f1;\n      }\n\n      .cls-65 {\n        fill: #96c3db;\n      }\n\n      .cls-66 {\n        fill: #fbcdc7;\n      }\n\n      .cls-67 {\n        fill: #80cebb;\n      }\n\n      .cls-68 {\n        fill: #ee917d;\n      }\n\n      .cls-69 {\n        fill: #fff;\n      }\n\n      .cls-70 {\n        fill: #e5ae56;\n      }\n\n      .cls-71 {\n        fill: #ffb65c;\n      }\n\n      .cls-72 {\n        fill: #ec6d53;\n      }\n\n      .cls-73 {\n        fill: #efbc5e;\n      }\n\n      .cls-74 {\n        fill: #f5dbb8;\n      }\n\n      .cls-75 {\n        fill: #677070;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m151.17,175.74c-24.05,0-48.09,0-72.14,0,0-12.89,0-25.78,0-38.66h72.14c0,12.89,0,25.78,0,38.66Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m285.3,175.4c-24.05,0-48.09,0-72.14,0,0-12.89,0-25.78,0-38.66h72.14c0,12.89,0,25.78,0,38.66Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m217.89,175.74c-24.05,0-48.09,0-72.14,0,0-12.89,0-25.78,0-38.66h72.14v38.66Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 11.97,
    y: 137.07,
    width: 72.14,
    height: 38.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.34,
    y: 20.9,
    width: 189.89,
    height: 116.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 21",
    x1: 107.23,
    y1: 83.87,
    x2: 110.86,
    y2: 250.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50475a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667380"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21-2",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 21",
    x1: 185.55,
    y1: 82.24,
    x2: 189.18,
    y2: 248.95,
    xlinkHref: "#_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 148.03,
    y1: 87.87,
    x2: 148.41,
    y2: 70.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d49e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e66d71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 159.29,
    y1: 55.87,
    x2: 167.01,
    y2: 55.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 127.5,
    y1: 54.94,
    x2: 132.97,
    y2: 54.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 147.18,
    y1: 69.06,
    x2: 147.59,
    y2: 25.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 243.66,
    y1: 92.21,
    x2: 202.64,
    y2: 127.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 238.82,
    y1: 87.87,
    x2: 198.61,
    y2: 122.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 245.15,
    y1: 94.31,
    x2: 204.47,
    y2: 129.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21-3",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 21",
    x1: 124.55,
    y1: 83.51,
    x2: 128.18,
    y2: 250.05,
    xlinkHref: "#_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21-4",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 21",
    x1: 168.2,
    y1: 82.61,
    x2: 171.83,
    y2: 249.21,
    xlinkHref: "#_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 144.83,
    y1: 91.39,
    x2: 151.44,
    y2: 91.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7742b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 137.2,
    y1: 129.35,
    x2: 155.18,
    y2: 129.35,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21-5",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 21",
    x1: 208.98,
    y1: 83.16,
    x2: 212.61,
    y2: 249.6,
    xlinkHref: "#_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 113.61,
    y1: 83.57,
    x2: 117.25,
    y2: 250.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47505a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667380"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u30DB\\u30EF\\u30A4\\u30C8_\\u30D6\\u30E9\\u30C3\\u30AF",
    "data-name": "\\u30DB\\u30EF\\u30A4\\u30C8\\u3001\\u30D6\\u30E9\\u30C3\\u30AF",
    x1: 144.71,
    y1: 86.63,
    x2: 151.04,
    y2: 174.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 119.45,
    y: 106.48,
    width: 408.83,
    height: 188.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 375.27,
    y1: 195.61,
    x2: 433.16,
    y2: 195.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b73ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000dff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 407.73,
    y1: 235.95,
    x2: 429.58,
    y2: 156.55,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 441.7,
    y1: 258.39,
    x2: 469.82,
    y2: 156.18,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 425.3,
    y1: 201.43,
    x2: 438.27,
    y2: 201.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5e085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 435.24,
    y1: 170.36,
    x2: 441.65,
    y2: 170.36,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 409.21,
    y1: 249.46,
    x2: 437.34,
    y2: 147.25,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 426.32,
    y1: 191.56,
    x2: 420.7,
    y2: 251.69,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 447.32,
    y1: 215.62,
    x2: 475.1,
    y2: 215.62,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 443.26,
    y1: 149.1,
    x2: 443.26,
    y2: 118.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b55d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 451.68,
    y1: 149.1,
    x2: 451.68,
    y2: 118.82,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 426.23,
    y1: 147.46,
    x2: 448.55,
    y2: 147.46,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 446.9,
    y1: 193.49,
    x2: 441.27,
    y2: 253.61,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 446.73,
    y1: 193.25,
    x2: 482.65,
    y2: 213.99,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 466.95,
    y1: 211.66,
    x2: 459.66,
    y2: 211.66,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 396.96,
    y1: -352.06,
    x2: 389.6,
    y2: -352.06,
    gradientTransform: "translate(-4.8 534.45) rotate(3.54)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -4997.67,
    y1: 142.13,
    x2: -4951.99,
    y2: 142.13,
    gradientTransform: "translate(-4591.97) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0bbe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bee2f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 319.29,
    y1: 254.53,
    x2: 319.29,
    y2: 225,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 129.8,
    y1: 235.33,
    x2: 508.78,
    y2: 235.33,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 305.65,
    y1: 222.26,
    x2: 364.1,
    y2: 222.26,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 281.5,
    y1: 239.68,
    x2: 351.28,
    y2: 239.68,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 271.82,
    y1: 275.16,
    x2: 271.82,
    y2: 355.45,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 226.92,
    y1: 177.34,
    x2: 257.15,
    y2: 177.34,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 275.57,
    y1: 260.02,
    x2: 275.57,
    y2: 353.65,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -4080.07,
    y1: -546.14,
    x2: -4069.63,
    y2: -546.14,
    gradientTransform: "translate(2496.45 3714.2) rotate(50.04)",
    xlinkHref: "#linear-gradient-11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 530,
    height: 300
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 8.81,
    y: 8.5,
    width: 278.04,
    height: 174.21,
    rx: 2.71,
    ry: 2.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m148.11,175.74c-22.24,0-44.49,0-66.73,0,0-12.89,0-25.78,0-38.66h66.73c0,12.89,0,25.78,0,38.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m127.42,156.14c-.58-2.04-2.34-3.57-3.12-5.54-.52-1.3-.52-2.78-1.14-4.04-1.2-2.43-3.72-4.06-6.42-4.5-1.41-.23-2.87-.17-4.26.14-.09.02-.18.04-.27.06-1.23.31-2.41.86-3.39,1.67-.2.16-.38.33-.56.51-.89.89-1.55,1.99-1.86,3.19-.26.99-.4,2.02-.78,2.98-.78,1.97-2.54,3.51-3.12,5.54-.26.92-.24,1.99.4,2.71.53.59,1.36.83,2.15,1,2.22.5,4.5.76,6.78.8,1.07.02,2.22-.04,3.1-.63.01,0,.03-.02.04-.03.01,0,.03.02.04.03.89.59,2.03.65,3.1.63,2.28-.03,4.55-.3,6.78-.8.79-.18,1.62-.41,2.15-1,.64-.72.67-1.79.4-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m119.6,171.06c-.26-4.08-.52-8.16-.78-12.23-1.27-.49-2.55-.97-3.82-1.46,0,0,0,0,0,0-1.27.49-2.55.97-3.82,1.46-.26,4.08-.52,8.16-.78,12.23,1.53-.2,3.06-.4,4.6-.6,0,0,0,0,0,0,1.53.2,3.06.4,4.59.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m111.16,159.29c2.1,2.4,4.92,4.11,8.02,5.05-.12-1.83-.23-3.67-.35-5.5-1.27-.49-2.55-.97-3.82-1.46,0,0,0,0,0,0-1.27.49-2.55.97-3.82,1.46,0,.15-.02.3-.03.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m134.69,188.5c-13.06,0-26.13,0-39.19,0,.34-3.83.68-7.67,1.02-11.5.13-1.51.28-3.06.91-4.46.63-1.4,1.84-2.67,3.44-3.05.7-.16,3.84-1.03,7.01-1.92.17-.05.35-.1.52-.15.1-.03.2-.06.3-.08.01,0,.03,0,.04-.01.11-.03.23-.06.34-.1,2.87-.81,5.51-1.55,6.02-1.69.52.15,3.24.92,6.18,1.74.11.03.22.06.34.09.29.08.59.16.88.25,3.11.87,6.15,1.71,6.84,1.87,1.6.38,2.81,1.64,3.44,3.05.63,1.4.77,2.95.91,4.46.34,3.83.68,7.67,1.02,11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m120.63,148.73c-.66-2.02-2.04-3.5-3.57-3.83-.19-.04-.38-.06-.57-.07-.51,0-2.47,0-2.98,0-.19,0-.38.03-.57.07-1.52.33-2.91,1.82-3.57,3.83-.56,1.71-.61,3.68-.42,5.55.16,1.59.4,2.24,1.1,3.48.78,1.37,1.82,2.39,2.94,3.11.5.32,1.04.67,1.6.8.06.02.12.03.18.04.07,0,.15.01.22.01.07,0,.15,0,.22-.01.06,0,.13-.02.18-.04.55-.13,1.1-.47,1.6-.8,1.11-.72,2.16-1.74,2.94-3.11.7-1.24.94-1.89,1.1-3.48.19-1.87.14-3.85-.42-5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m109.21,151.6c-.02-.34-.18-.64-.41-.81-.19-.14-.39-.25-.61-.33-.36-.12-.77-.06-1.03.27-.29.38-.31.98-.22,1.5.19,1.09.79,2.02,1.47,2.69.12.12.28.18.43.15.38-.08.44-.6.44-1.02,0-.82-.02-1.64-.08-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m120.79,151.6c.02-.34.18-.64.41-.81.19-.14.39-.25.61-.33.36-.12.77-.06,1.03.27.29.38.31.98.22,1.5-.19,1.09-.79,2.02-1.47,2.69-.12.12-.28.18-.43.15-.38-.08-.44-.6-.44-1.02,0-.82.02-1.64.08-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m103.92,182.73c-.06-.79-.21-1.5-.5-2.24-.29-.74-.47-1.52-.55-2.31-.04-.39-.07-.79-.11-1.18-.02-.21-.04-.41-.06-.62-.02-.18-.35.77-.45,1.49-.48,3.18-.51,6.59-.1,9.97.03.23.08.45.16.65.68,0,1.35,0,2.03,0,0,0-.41-5.76-.41-5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m109.29,147.71c3.93,0,7.87,0,11.8,0-.89-1.3-1.78-2.6-2.67-3.9-1.46-.26-2.93-.51-4.39-.77-1.04.26-2.08.51-3.12.77-.54,1.3-1.08,2.6-1.62,3.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m114.52,179.54c.36.46.62.99.78,1.55.05.18.33.1.28-.08-.16-.58-.44-1.13-.81-1.61-.05-.06-.13-.09-.2-.05-.06.04-.1.13-.05.19t0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m115.84,179.54c-.36.46-.62.99-.78,1.55-.05.18-.33.1-.28-.08.16-.58.44-1.13.81-1.61.05-.06.13-.09.2-.05.06.04.1.13.05.19t0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m126.27,182.73c.06-.79.21-1.5.5-2.24.29-.74.47-1.52.55-2.31.04-.39.07-.79.11-1.18.02-.21.04-.41.06-.62.02-.18.35.77.45,1.49.48,3.18.51,6.59.1,9.97-.03.23-.08.45-.16.65-.68,0-1.35,0-2.03,0,0,0,.41-5.76.41-5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m127.07,179.89c-.55-1.18-1.45-2.03-2.21-3.01-.59-.75-1.13-1.72-1.59-2.8-.48-2.1-.75-4.28-.78-6.47-.29-.08-.59-.16-.88-.25-.11-.03-.22-.06-.34-.09-.19,1.19-.38,2.38-.53,3.32-.12.74-.21,1.33-.25,1.63-.36,2.46-.98,5-2.52,6.65-.69.74-1.51,1.22-2.37,1.5-.14.04-.29.08-.43.12-.14-.03-.29-.07-.43-.12-.86-.27-1.69-.76-2.37-1.5-1.53-1.64-2.16-4.18-2.51-6.65-.05-.31-.14-.92-.26-1.68-.15-.93-.33-2.11-.52-3.28,0-.01,0-.03,0-.04-.11.03-.23.06-.34.1-.01,0-.03,0-.04.01-.1.03-.2.06-.3.08-.17.05-.35.1-.52.15-.03,2.16-.29,4.32-.76,6.41-.47,1.12-1.02,2.12-1.63,2.9-.77.98-1.67,1.83-2.22,3.01-.7,1.5-.71,3.35-.36,5.02.27,1.26.74,2.44,1.25,3.59.54,0,1.08,0,1.63,0,6.27,0,12.53,0,18.8,0,.53,0,1.07,0,1.6,0,.51-1.15.98-2.33,1.25-3.59.36-1.67.34-3.52-.36-5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m114.96,158.69c1.25,0,2.26-.98,2.26-2.19h-4.51c0,1.21,1.01,2.19,2.26,2.19Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m281.57,137.07c-88.85,0-177.71,0-266.56,0,0-38.66,0-77.33,0-115.99h266.56c0,38.66,0,77.33,0,115.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m281.57,175.74c-22.24,0-44.49,0-66.73,0,0-12.89,0-25.78,0-38.66h66.73c0,12.89,0,25.78,0,38.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m242.04,147.02c-.53,8.11-1.07,16.21-1.6,24.32h8.68c0-8.24,0-16.48,0-24.71-2.36.13-4.72.27-7.09.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m256.2,147.02c.53,8.11,1.07,16.21,1.6,24.32h-8.68c0-8.24,0-16.48,0-24.71,2.36.13,4.72.27,7.09.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m268.82,188.05c-13.06,0-26.13,0-39.2,0,.34-3.83.68-7.67,1.02-11.5.13-1.51.28-3.06.91-4.46.63-1.4,1.84-2.67,3.44-3.05,1.44-.34,13.09-3.63,14.23-3.95,1.15.32,12.8,3.61,14.23,3.95,1.6.37,2.81,1.64,3.44,3.05.63,1.4.77,2.95.91,4.46.34,3.83.68,7.67,1.02,11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m256.21,147.02c-.13-1.55-.82-3.12-2.05-4.17-1.36-1.16-3.27-1.34-5.01-1.36-1.42-.02-2.87.18-4.18.75-1.91.84-2.77,2.85-2.93,4.78-.15,1.68.18,3.36.51,5.01,0,0,6.57.42,6.57.42,0,0,0,0,0,0,0,0,0,0,0,0,2.19-.14,4.38-.28,6.57-.42.33-1.65.66-3.33.51-5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m253.45,166.17c-.16-2.6-.33-5.19-.49-7.79-1.27-.49-2.55-.97-3.82-1.46,0,0,0,0,0,0-1.27.49-2.55.97-3.82,1.46-.16,2.59-.33,5.19-.49,7.78-.04.7.34,1.33.89,1.87,1.88,1.83,4.98,1.83,6.85,0,.55-.54.93-1.17.88-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m245.29,158.84c2.1,2.4,4.92,4.11,8.02,5.05-.12-1.83-.23-3.67-.35-5.5-1.27-.49-2.55-.97-3.82-1.46,0,0,0,0,0,0-1.27.49-2.55.97-3.82,1.46,0,.15-.02.3-.03.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m254.76,148.28c-.66-2.02-2.04-3.5-3.57-3.83-.19-.04-.38-.06-.57-.07-.51,0-2.47,0-2.98,0-.19,0-.38.02-.57.07-1.52.33-2.91,1.82-3.57,3.83-.56,1.71-.6,3.68-.42,5.55.16,1.59.4,2.24,1.1,3.48.78,1.37,1.82,2.39,2.94,3.11.5.32,1.04.67,1.6.8.06.02.12.03.18.04.07,0,.15.01.22.01.07,0,.15,0,.22-.01.06,0,.13-.02.18-.04.56-.13,1.1-.47,1.6-.8,1.11-.72,2.16-1.74,2.94-3.11.7-1.24.94-1.89,1.1-3.48.19-1.87.14-3.85-.42-5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m243.34,151.15c-.02-.34-.18-.64-.41-.81-.19-.14-.39-.25-.61-.33-.36-.12-.77-.06-1.03.27-.29.38-.31.98-.22,1.5.19,1.09.79,2.02,1.47,2.69.12.12.28.18.43.15.38-.08.44-.6.44-1.02,0-.82-.02-1.64-.08-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m254.92,151.15c.02-.34.18-.64.41-.81.19-.14.39-.25.61-.33.36-.12.77-.06,1.03.27.29.38.31.98.22,1.5-.19,1.09-.79,2.02-1.47,2.69-.12.12-.28.18-.43.15-.38-.08-.44-.6-.44-1.02,0-.82.02-1.64.08-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m246,142.91c.24-.24.61-.28.94-.29,1.18-.06,2.37.02,3.53.22,1.46.25,2.96.76,3.89,1.88.91,1.09,1.02,2.57,1.29,3.94.04.21.08.43.13.64-1.28.19-2.66-.54-3.18-1.7-.27-.6-.36-1.34-.9-1.74-.48-.36-1.14-.32-1.74-.29-.72.03-1.46.02-2.15-.17-.7-.19-1.35-.57-1.76-1.15-.28-.4-.4-.99-.06-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m236.55,187.97c.31-2.85.12-5.74-.57-8.41-.13-.51-.28-1.02-.45-1.51-.03.79-.06,1.58-.08,2.36-.01.3-.02.59-.03.88,0,2.22,0,4.45-.01,6.67.38,0,.76,0,1.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m261.74,187.97c-.31-2.85-.12-5.74.57-8.41.13-.51.28-1.02.45-1.51.03.79.06,1.58.08,2.36.01.3.02.59.03.88,0,2.22,0,4.45.01,6.67-.38,0-.76,0-1.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m249.12,158.23c1.25,0,2.26-.98,2.26-2.19-1.51,0-3.01,0-4.51,0,0,1.21,1.01,2.19,2.26,2.19Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m214.84,175.74c-22.24,0-44.49,0-66.73,0,0-12.89,0-25.78,0-38.66h66.73v38.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m201.98,176.78c-.13-1.53-.27-3.08-.88-4.5-.61-1.42-1.79-2.7-3.35-3.08-.16-.04-.48-.12-.9-.23-.62-.19-1.26-.35-1.88-.5-4.36-1.17-12.1-3.28-12.1-3.28,0,0,0,0,0,0-.01,0-.02,0-.03,0-.2.22-.55.43-1.01.63-.46-.2-.81-.4-1.01-.63-.01,0-.02,0-.03,0,0,0,0,0,0,0,0,0-7.73,2.11-12.1,3.28-.62.15-1.25.31-1.88.5-.42.11-.73.19-.9.23-1.56.38-2.74,1.66-3.35,3.08-.61,1.42-.75,2.97-.88,4.5-.33,3.87-.66,7.74-.99,11.61h42.28c-.33-3.87-.66-7.74-.99-11.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m186.51,166.18s-.01.01-.02.02c-2.72,2.14-6.61,2.13-9.32-.02h0c.14-2.14.27-4.28.41-6.42,1.42-.54,2.84-1.09,4.26-1.63h0c1.42.54,2.84,1.08,4.26,1.63.14,2.14.27,4.29.41,6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m177.54,160.26c2.34,2.68,5.49,4.59,8.95,5.63-.13-2.05-.26-4.09-.39-6.14-1.42-.54-2.84-1.09-4.26-1.63,0,0,0,0,0,0-1.42.54-2.84,1.09-4.26,1.63-.01.17-.02.34-.03.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m189.73,147.07c-.15-1.73-.92-3.48-2.29-4.65-1.52-1.3-3.64-1.49-5.59-1.52-1.58-.02-3.21.2-4.66.83-2.14.93-3.09,3.17-3.27,5.33-.16,1.87.2,3.74.57,5.59,0,0,7.33.47,7.33.47,0,0,0,0,0,0,0,0,0,0,0,0,2.44-.16,4.89-.31,7.33-.47.36-1.84.73-3.72.57-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m188.11,148.48c-.74-2.25-2.28-3.91-3.98-4.28-.21-.05-.42-.07-.64-.07-.57,0-2.76,0-3.32,0-.21,0-.42.03-.64.07-1.7.37-3.24,2.03-3.98,4.28-.62,1.91-.67,4.11-.47,6.2.18,1.77.44,2.5,1.23,3.88.87,1.53,2.04,2.67,3.28,3.47.56.36,3.91.36,4.47,0,1.24-.8,2.41-1.94,3.28-3.47.79-1.38,1.05-2.11,1.23-3.88.21-2.09.16-4.29-.47-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m188.29,151.68c.03-.38.2-.72.45-.9.21-.15.44-.28.68-.36.4-.14.86-.07,1.15.31.32.42.35,1.1.24,1.67-.21,1.22-.88,2.25-1.64,3-.14.13-.31.2-.48.16-.43-.09-.49-.67-.49-1.14,0-.91.03-1.83.09-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m168.55,188.39c.31-2.85.12-5.74-.57-8.41-.13-.51-.28-1.02-.45-1.51-.03.79-.06,1.58-.08,2.36-.01.29-.02.59-.03.88,0,2.22,0,4.45-.01,6.67h1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m195.11,188.39c-.31-2.85-.12-5.74.57-8.41.13-.51.28-1.02.45-1.51.03.79.06,1.58.08,2.36.01.29.02.59.03.88,0,2.22,0,4.45.01,6.67h-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m189.78,147.24c0-.06,0-.11,0-.17,0-.46-.04-.93-.11-1.38-.21-1.33-.69-2.64-1.58-3.69-1.33-1.57-3.34-2.13-5.36-2.25-.61-.04-1.23-.03-1.82,0-1.55.08-3.11.42-4.36,1.36-1.11.83-1.85,2.03-2.25,3.33-.26.85-.4,1.75-.4,2.64h0c0,.31,0,.62,0,.94,0,0,0,0,0,0,.08,0,.15.05.17.12.25.82.72,2.37.77,2.41.33-1.81,1.31-3.43,2.92-4.43,2.21-1.36,5.31-1.45,7.63-.29.33.16.64.35.93.56.61.44,1.14.99,1.54,1.62.24.36.43.75.59,1.16.09.22.16.45.23.68.02.08.21.62.17.7.07-.11.48-1.47.73-2.29.07.01.13.03.2.04,0-.01,0-.03,0-.04,0-.04,0-.07,0-.11,0-.05,0-.1,0-.15,0-.06,0-.11,0-.17,0-.05,0-.11,0-.16,0-.04,0-.08,0-.13,0-.03,0-.05,0-.08,0-.07,0-.13,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m181.91,159.48c1.25,0,2.26-.98,2.26-2.19h-4.51c0,1.21,1.01,2.19,2.26,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m184.16,143.97s-2.09,4.42-9.18,7.29c.13,0-.85-2.65-.85-2.65.76-1.16,1.52-2.32,2.28-3.48,2.58-.38,5.17-.77,7.75-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m175.38,151.68c-.03-.38-.2-.72-.45-.9-.21-.15-.44-.28-.68-.36-.4-.14-.86-.07-1.15.31-.32.42-.35,1.1-.24,1.67.21,1.22.88,2.25,1.64,3,.14.13.31.2.48.16.43-.09.49-.67.49-1.14,0-.91-.02-1.83-.09-2.74Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 15.01,
    y: 137.07,
    width: 66.37,
    height: 38.66
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m68.19,176.78c-.13-1.53-.27-3.08-.88-4.5-.61-1.42-1.79-2.7-3.35-3.08-.16-.04-.47-.12-.9-.23-.62-.19-1.26-.35-1.88-.5-4.36-1.17-12.1-3.28-12.1-3.28,0,0,0,0,0,0-.01,0-.02,0-.03,0-.2.22-.55.43-1.01.63-.46-.2-.81-.4-1.01-.63-.01,0-.02,0-.03,0,0,0,0,0,0,0,0,0-7.73,2.11-12.1,3.28-.62.15-1.25.31-1.88.5-.42.11-.73.19-.9.23-1.56.38-2.74,1.66-3.35,3.08-.61,1.42-.75,2.97-.88,4.5-.33,3.87-.66,7.74-.99,11.61h42.28c-.33-3.87-.66-7.74-.99-11.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m52.72,166.18l-.02.02c-2.72,2.14-6.61,2.13-9.32-.02h0c.14-2.14.27-4.28.41-6.42,1.42-.54,2.84-1.09,4.26-1.63h0c1.42.54,2.84,1.08,4.26,1.63.14,2.14.27,4.29.41,6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m43.76,160.26c2.34,2.68,5.49,4.59,8.95,5.63-.13-2.05-.26-4.1-.39-6.14-1.42-.54-2.84-1.09-4.26-1.63h0c-1.42.55-2.84,1.09-4.26,1.63-.01.17-.02.34-.03.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m55.95,147.07c-.15-1.73-.92-3.48-2.29-4.65-1.52-1.3-3.64-1.49-5.59-1.52-1.58-.02-3.21.2-4.66.83-2.14.94-3.09,3.17-3.27,5.33-.16,1.87.2,3.74.57,5.59,0,0,7.33.47,7.33.47,0,0,0,0,0,0,0,0,0,0,0,0,2.44-.16,4.89-.31,7.33-.47.36-1.84.73-3.72.57-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m54.32,148.48c-.74-2.25-2.28-3.91-3.98-4.28-.21-.05-.42-.07-.64-.07-.57,0-2.76,0-3.32,0-.21,0-.43.03-.64.07-1.7.37-3.24,2.03-3.98,4.28-.62,1.91-.68,4.11-.47,6.2.18,1.77.44,2.5,1.23,3.88.87,1.53,2.04,2.67,3.28,3.47.56.36,3.91.36,4.47,0,1.24-.8,2.41-1.94,3.28-3.47.79-1.38,1.05-2.11,1.23-3.88.21-2.09.16-4.29-.47-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m41.59,151.68c-.03-.38-.2-.72-.45-.9-.21-.15-.44-.28-.68-.36-.4-.14-.86-.07-1.15.31-.32.42-.35,1.09-.24,1.67.21,1.22.88,2.25,1.64,3,.14.13.31.2.48.16.43-.09.49-.67.49-1.14,0-.91-.02-1.83-.09-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m54.5,151.68c.03-.38.2-.72.45-.9.21-.15.44-.28.68-.36.4-.14.86-.07,1.15.31.32.42.35,1.09.24,1.67-.21,1.22-.88,2.25-1.64,3-.14.13-.31.2-.48.16-.43-.09-.49-.67-.49-1.14,0-.91.02-1.83.09-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m34.77,188.39c.31-2.85.12-5.74-.57-8.41-.13-.51-.28-1.02-.45-1.51-.03.79-.06,1.58-.08,2.36-.01.29-.02.59-.03.88,0,2.22,0,4.45-.01,6.67h1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m61.33,188.39c-.31-2.85-.12-5.74.57-8.41.13-.51.28-1.02.45-1.51.03.79.06,1.58.08,2.36.01.29.02.59.03.88,0,2.22,0,4.45.01,6.67h-1.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m40.1,147c.73-2.28,1.17-4.2,3.44-5.53,2.26-1.33,5.27-1.16,7.59-.05.59.28,3.52,1.79,2.27,2.61-.05.03-.1.06-.16.08-.25.1-.5.44-.33.76.26.48-.06,1.07-.49,1.41-.62.5-1.45.71-2.26.7-.81,0-1.6-.21-2.36-.47-.64-.21-1.33-.46-1.96-.22-.71.27-1.04,1.02-1.53,1.59-.93,1.08-2.64,1.45-3.95.85.11-.22.05-1.63-.26-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m55.99,147.24c0-.06,0-.11,0-.17,0-.46-.04-.93-.11-1.38-.21-1.33-.69-2.64-1.58-3.69-1.33-1.57-3.34-2.13-5.36-2.25-.61-.04-1.23-.03-1.82,0-1.55.08-3.11.42-4.36,1.36-1.11.83-1.85,2.03-2.25,3.33-.26.85-.39,1.75-.4,2.64h0v.94s0,0,0,0c.08,0,.15.05.17.12.25.82.72,2.37.77,2.41.33-1.81,1.31-3.43,2.92-4.43,2.21-1.36,5.31-1.45,7.63-.29.33.16.64.35.93.56.61.44,1.14.99,1.54,1.62.24.36.43.75.59,1.16.09.22.16.45.23.68.02.08.21.62.17.7.07-.11.48-1.47.73-2.29l.2.04s0-.03,0-.04c0-.04,0-.07,0-.11,0-.05,0-.1,0-.15,0-.06,0-.11,0-.17,0-.05,0-.11,0-.16,0-.04,0-.08,0-.13,0-.03,0-.05,0-.08,0-.07,0-.13,0-.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m48.12,159.48c1.25,0,2.26-.98,2.26-2.19h-4.51c0,1.21,1.01,2.19,2.26,2.19Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m281.57,21.08c-88.89,0-177.78,0-266.67,0v-7.72c88.89,0,177.78,0,266.67,0v7.72Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m270.19,17.23c0,1.13-.9,2.04-2,2.04-1.1,0-2-.92-2-2.04,0-1.13.9-2.04,2-2.04,1.1,0,2,.92,2,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m264.01,17.23c0,1.13-.9,2.04-2,2.04-1.1,0-2-.92-2-2.04,0-1.13.9-2.04,2-2.04,1.1,0,2,.92,2,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m257.84,17.23c0,1.13-.9,2.04-2,2.04-1.1,0-2-.92-2-2.04,0-1.13.9-2.04,2-2.04,1.1,0,2,.92,2,2.04Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m117.18,130.65c-2.6,4.22-5.4,8.27-7.88,12.11-.11.17-.22.35-.34.51-.25.39-.51.78-.78,1.17-1.52,2.26-3.25,4.44-5.69,5.85-2.58,1.5-6.28,1.68-9.02.51-2.1-.91-3.64-2.6-3.64-5.1-.02-2.19.96-4.27,1.92-6.28,3.65-7.65,7.31-15.31,10.97-22.96,2.41-5.04,4.81-10.07,7.22-15.12,1.19-2.49,2.45-5.08,4.73-6.85,2.27-1.77,5.87-2.47,8.26-.84,1.6,1.09,2.33,2.93,2.74,4.7,2.79,11.3-2.31,22.28-8.48,32.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m222.86,112.46c-2.5-.08-5.06-.73-6.91-2.27-1.61-1.33-2.54-3.42-2.17-5.33.09-.47.48-.8,1-.69,3.93.83,7.62,3.1,9.82,6.17.12.17.22.4.29.64.14.48-.14,1.11-.64,1.31-.43.17-.91.18-1.38.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m200.42,151.73c-3.93-.46-4.44.42-9.9-5.58-.28-.31-.55-.61-.83-.91h0c-3.42-3.77-6.8-7.54-9.93-11.5-2.66-3.37-5.35-6.79-7.53-10.42-1.45-2.41-2.67-4.91-3.51-7.55-1.04-3.24-1.48-6.63-2.79-9.78-.75-1.81-1.77-3.52-2.32-5.39-.54-1.87-.52-3.99.69-5.57,1.21-1.59,4.76-3,6.76-2.37,3.06.98,6.77.93,9.87,1.97,2.87.96,3.96,3.6,4.9,5.92,1.34,3.3,3.28,6.45,4.99,9.61,6.34,11.74,12.28,23.5,18.5,35.27,1.71,3.24-4.96,6.77-8.89,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m164.51,88.66c0,11.12-.35,24.85-.35,35.97,0,4.82,0,9.63-.4,14.43-.38,4.59-1.13,9.15-1.55,13.73-.55,5.93-.56,11.88-.05,17.81h-37.31c-.25-1.35-.48-2.7-.7-4.05-1.94-12.01-3.02-24.15-3.21-36.29-.12-7.26.08-14.52.59-21.77.25-3.42.27-6.58,1.77-9.69,1.38-2.89,3.16-5.68,5.03-8.34,1.03-1.45,3.28-1.78,4.83-2.78,2.47-1.58,2.94-2,5.44-1.39,2.95.71,6.59.82,9.64.96,2.08.09,4.17.25,6.25.3,1.16.02,2.31-.26,3.42-.56.49-.13,1.04-1.18,1.54-1.19,3.62-.04,5.03-.61,5.03,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m157.65,82.68c-.53,1.28-2.13,1.92-3.14,2.3-2.99,1.13-6.73,2.22-9.34,4.41-.97.81-1.04,2.37-2.18,2.32-1.3-.06-2.28-1.34-3.12-2.53-.65-.94-1.34-1.95-1.44-3.19-.09-1.03.24-2.07.48-3.08.09-.37.17-.74.24-1.1.66-3.45.53-7.04.41-10.55-.04-1.01,0-2.18.44-2.99.1-.21.25-.38.41-.53.24-.21.51-.34.75-.54.55-.46.84-1.24,1.21-1.91,1.56-2.92,4.69-4.28,7.39-3.62,2.71.67,4.94,3.45,6.17,6.45-.67,3.67-.26,7.56,1.12,10.8.45,1.05,1.13,2.53.6,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m159.29,61.83c.57-2.63,1.15-5.26,1.72-7.88.22-1.01.46-2.05,1.11-2.87.9-1.12,2.77-1.6,3.92-.72.82.63,1.06,1.75.94,2.75-.26,2.25-1.95,4.11-3.7,5.65-1.26,1.11-2.59,2.14-3.99,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m132.27,49.78c.47.63.58,1.43.64,2.19.23,3.07-.16,6.19-1.16,9.12-2.28-2.29-3.76-5.27-4.18-8.39-.11-.86-.14-1.76.27-2.54.4-.75,1.22-1.3,2.11-1.38.89-.08,1.81.31,2.32.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m159.99,66.31c-1.31,2.68-3.28,4.99-6.31,6.58-4.71,2.47-10.98,1.71-15.26-1.05-6.75-4.36-7.58-11.89-7.56-18.82.02-5.38.12-12.04,2.85-16.89,1.25-2.22,3.15-4.18,5.57-5.22,2.16-.92,4.6-1.05,6.97-.95,2.95.13,5.88.62,8.7,1.45,4.49,1.31,7.74,4.03,8.65,8.55.61,3,.19,6.09-.22,9.13-.73,5.38-.82,12-3.38,17.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m160.2,29.08c-1.34-1.67-3.28-2.97-5.42-3.72-3.4-1.2-7.22-1.12-10.77-.34-4.59,1.01-8.96,3.24-11.8,6.67-2.41,2.9-3.55,6.63-2.96,10.24.27,1.67.17,3.26.38,4.95.11.92.27,1.85.5,2.75.14.53.8,1.64.72,2.14.31-1.86.73-4.28,1.27-5.95.7-2.14,1.84-4.15,3.34-5.89,3.45-3.99,6.64-.64,10.07,1.32,2.51,1.43,5.72,1.81,8.55,1.01,4.21-1.19,8.82-5.69,7.8-9.87-.29-1.2-.88-2.32-1.68-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m166.65,39.34c.18,3.6-1.27,7.95-2.43,11.15-.2.54-.4,1.08-.61,1.61-.11.28-.23.55-.34.83-.04.09-.58,1.01-.56,1.07-.03-.06.02-.69,0-.75-.88-1.89-2-3.43-2.73-5.39-1.04-2.8-.48-6.14-2.78-8.44-1.19-1.19-2.72-1.8-4.08-2.76-.47-.33-.95-.73-1.28-1.18-.13-.18-.72-1.82-.7-1.82,2.3.68,2.81-2,4.41-2.55,1.96-.67,4.87.13,6.56,1.05,2.32,1.27,3.98,3.49,4.4,5.92.07.41.12.83.14,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m148.36,87.32l-6.5,8.8-9.58-9.02,6.82-5.33s2.33,4.19,9.25,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m148.36,87.32l5.42,8.74,10.21-8.36-6.23-7.25s-2.45,5.42-9.4,6.88Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m225.67,108.71c-1.37.83-2.63,1.85-4.15,2.41-1.53.56-3.48.54-4.6-.56-.84-.81-1.02-2.04-.77-3.13.25-1.09.88-2.07,1.5-3.03.95-1.45,2.05-2.99,3.79-3.59,1.87-.65,3.95-.03,5.89.4,5.99,1.35,15.57-.99,18.17-1.17.41.72.1,1.64-.5,2.24-.61.59-1.46.93-2.3,1.21-5.64,1.89-12.01,2.21-17.02,5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m228.7,95.02c.25.28.33.71.34,1.09.07,3.89-3.3,7.2-7.51,7.53-.66.05-1.43.02-1.85-.45-.37-.42-.31-1.05-.01-1.51.3-.46.78-.8,1.25-1.12,1.04-.71,2.08-1.42,3.12-2.12,1.27-.87,2.03-1.76,2.85-2.97.3-.45.85-.88,1.41-.72.17.05.3.14.41.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m242.02,97.81c-.24,1.55-.61,3.28-2.04,4.16-.68.42-1.51.58-2.32.72-.89.15-1.79.3-2.7.26-.91-.04-1.83-.27-2.52-.8,3.39-.63,6.49-2.43,8.53-4.96.14-.17.3-.36.52-.37.24-.02.44.16.51.37.07.2.04.42,0,.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m116.94,145.66c.3-15.43.29-31.88-2.47-47.11-.21-1.18-.42-2.44.13-3.53.74-1.47,2.53-2.1,4.16-2.37,2-.33,3.87-1.01,5.74-1.79,4.02-1.68,7.77-3.88,11.09-6.52-1.08,5.89-1.64,11.86-1.7,17.83-.05,5.71,1.25,11.37,1.63,17.08.47,7.59.86,15.17,1.16,22.77.37,9.52.62,19.07.7,28.59h-21.95c.84-8.29,1.34-16.61,1.51-24.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m180.95,102.59c-3.87,14.2-4.61,24.95-4.22,38.82.03,1.44.09,2.92.15,4.44.28,6.7,1.18,17.23,1.34,24.75h-21.33c.08-5.51.2-11.01.35-16.51.2-7.97.46-15.95.78-23.91.32-7.62,2.21-14.85,3.83-22.35.82-3.82,1.46-7.78,1.7-11.68.13-2.13-.78-8.9-2.09-11.41,3.49,2.61,7.48,4.56,11.47,6.44,3.42,1.61,8.35,2.25,8.79,6.34.18,1.71-.31,3.41-.76,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m148.31,87.28c-1.04,1.59-1.95,2.77-3.09,4.29-.05,0-.33.42-.38.42.31,1.25.77,2.34,1.43,3.47,1.17.03,2.4.01,3.57.04.4-1.05,1.05-2.26,1.6-3.25-1.23-1.75-1.89-3.44-3.14-4.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "146.27 95.46 137.2 155.73 145.76 163.24 155.18 156.89 149.84 95.51 146.27 95.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m195.15,146.59c-.64-3.53.52-7.58,2.07-10.56,4.36-8.37,8.71-16.75,13.07-25.12.6-1.15,3.76-6.61,3.76-6.61,0,0,.08.48,1.06,1.54,2.64,2.86,6.42,4.61,9.85,6.12-.89-.39-13.05,30.53-14.11,32.96-1.32,3.01-2.88,6.29-5.67,7.51-3.03,1.33-6.45.61-8.54-2.26-.78-1.08-1.25-2.29-1.49-3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m136.71,142.67c-.09,0-.17-.05-.21-.13-5.23-11.39-9.98-23.7-14.57-35.6-.8-2.09-1.6-4.16-2.4-6.2l-.06-.16.16-.09c3.55-1.97,6.25-3.41,8.92-4.76-1.42-.49-2.78-1.01-4.1-1.52-1.46-.56-2.96-1.14-4.55-1.67l-.56-.19,1.26-.45c5.42-1.92,11.03-3.9,14.83-7.72.08-.08.23-.09.32-.01.09.08.1.21.02.29-3.87,3.89-9.53,5.89-15,7.83l-.15.05c1.39.48,2.72.99,4.01,1.49,1.46.56,2.96,1.14,4.54,1.67l.47.16-.44.22c-2.77,1.38-5.52,2.85-9.18,4.88.77,2,1.55,4.01,2.34,6.05,4.59,11.89,9.33,24.19,14.56,35.58.05.11,0,.23-.12.27-.03.01-.06.02-.09.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m157.62,141.53s-.06,0-.08-.01c-.12-.04-.17-.16-.13-.27l.25-.57c11.59-26.35,16.82-35.98,19.16-39.4-1.51-1.06-3.02-2.15-4.47-3.2-1.51-1.09-3.06-2.22-4.63-3.31l-.34-.24.41-.12c1.75-.5,3.81-.81,5.8-1.11.92-.14,1.81-.27,2.65-.42-5.06-1.58-10.25-4.4-14.72-8-.09-.08-.1-.21-.02-.29.08-.09.23-.09.32-.02,4.65,3.76,10.11,6.65,15.36,8.15l.81.23-.83.17c-1.09.22-2.26.39-3.5.58-1.82.27-3.69.55-5.32.98,1.45,1.02,2.89,2.06,4.28,3.07,1.5,1.09,3.06,2.22,4.63,3.31l.17.12-.11.16c-2.28,3.26-7.47,12.76-19.24,39.49l-.25.57c-.04.08-.12.13-.21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m161.13,150.69c0,.9-.46,1.63-1.02,1.63s-1.02-.73-1.02-1.63.46-1.63,1.02-1.63,1.02.73,1.02,1.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m143.28,152c-2.53.49-5.25.52-7.63-.42-2.38-.95-4.34-3-4.53-5.37.18-.69.76-1.24,1.44-1.57.68-.33,1.45-.48,2.2-.6,2.65-.42,5.35-.62,8.04-.59-1.13,2.7-.33,5.74.47,8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m99.57,154.02c-5.26-.74-10.81-2.71-9.65-8.12,1.65-7.71,19.07-6.79,25.35-6.36,4.47.31,8.91.98,13.3,1.81,2.07.39,4.21,1.08,6.28,1.36,1.75.24,3.38.04,5.07.73-.68-.31-1.19,3.97-1.18,4.35.05,1.71.92,3.23,1.61,4.82-5.61,1.25-11.25,1.84-17.03,1.94-5.95.1-11.9.08-17.85-.08-1.58-.04-3.72-.14-5.91-.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m184.81,113.93h-72.9c-1.77,0-3.2,1.3-3.2,2.9v40.76c0,1.6,1.43,2.9,3.2,2.9h72.9c1.77,0,3.2-1.3,3.2-2.9v-40.76c0-1.6-1.43-2.9-3.2-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m141.02,97.07c1.15-1.67,2.32-3.32,3.52-4.96,1.2-1.64,2.41-3.27,3.63-4.9l.2-.27.18.29c1.02,1.63,2.05,3.26,3.05,4.9,1.01,1.64,1.99,3.29,2.95,4.95-1.1-1.59-2.19-3.18-3.25-4.8-1.07-1.61-2.1-3.23-3.14-4.85h.38c-1.23,1.63-2.46,3.25-3.7,4.86-1.25,1.61-2.52,3.2-3.81,4.78Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m422.97,270.98c7.61,0,13.79-3.51,13.79-7.85h-27.57c0,4.33,6.17,7.85,13.79,7.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 420.89,
    y: 270.98,
    width: 5.41,
    height: 56.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m406.41,263.13l59.7-.29s11.6-2.81,14.6-9.05c3.96-8.24,5.94-42.38,14.37-72.56h-50.15c-8.43,30.17-10.41,64.31-14.37,72.56-2.99,6.24-14.6,9.05-14.6,9.05l-45.87.25,36.33.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m406.41,264.88l-36.33-.04c-.96,0-1.74-.78-1.74-1.74,0-.96.77-1.74,1.74-1.75l45.66-.25c3.15-.8,11.13-3.66,13.24-8.06,1.69-3.53,3.08-12.62,4.83-24.14,2.15-14.09,4.82-31.63,9.43-48.13.21-.75.9-1.28,1.68-1.28h50.15c.55,0,1.06.26,1.39.69.33.43.44,1,.29,1.53-4.55,16.3-7.21,33.72-9.34,47.72-1.87,12.27-3.22,21.13-5.14,25.13-3.31,6.9-15.26,9.87-15.76,9.99-.13.03-.27.05-.4.05l-59.7.29h-.01Zm39.84-81.9c-4.34,15.93-6.91,32.81-8.99,46.44-1.87,12.27-3.22,21.13-5.14,25.13-1.41,2.93-4.37,5.15-7.36,6.75l41.12-.2c3.15-.8,11.13-3.66,13.24-8.06,1.69-3.53,3.08-12.62,4.83-24.14,2.05-13.46,4.58-30.07,8.82-45.92h-46.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m382.88,223.98c-6.51.11-5.91-.47-10.01,2.4-1.34.94-4.03.78-7.51.99-2.79.17-5.23,1.25-6.18.38-2.07-1.9,7.1-2.57,6.51-3.14,0,0-2.4-1.01-6.29-.44-3.38.5-8.23,3.04-9.43,1.21-.44-.64.73-1.25,2.66-2.59,1.92-1.34,4.53-3.28,7.69-4.02,4.45-1.04,8.69-.18,14.5-.18,1.25,0,5.49-.11,7.32-1.21,2.34-1.42,1.24,6.58.74,6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m382.14,217.39c-1.82,1.1-6.07,1.21-7.31,1.21-.95,0-1.86-.03-2.74-.06.27.71.74,2.37.13,4.33-.49,1.56-1.53,3.46-4.05,4.38,2.11-.09,3.76-.2,4.71-.87,4.11-2.88,3.5-2.3,10.01-2.4.5-.01,1.6-8.01-.74-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m379.21,225l-4.42.09s.39-5.18-1.76-6.61l5.35-1.36,2.2,4.29-1.37,3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m417.57,222.18c-9.13,2.02-32.27,4-40.49,4.01.37-.23,1.76-8.36-1.81-10.68,5.5-1.83,27.77-9.26,33.71-8.51.61-6.1,2.29-18.47,7.29-36.08,1.5-5.25,5.64-7.55,11.13-4.63,3.71,1.98,5.59,7.59,5.75,11.32.61,14.63-13.36,44.08-15.57,44.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m429.18,167.65c-.54-.54-1.14-1.01-1.79-1.36-5.49-2.92-9.63-.62-11.13,4.63-.04.15-.08.3-.13.46-.12,1-.24,2.05-.48,3.18-3.95,18.55,4.47,30.61,2.16,44.72-.21,1.3-.53,2.21-.85,3.03.21-.04.41-.09.61-.13.86-.19,3.51-4.78,6.38-11.18-.32-17.09,1.7-33.05,5.23-43.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m437.93,236.14c-.9-3.97.69-14.6-4.33-14.83-5.62-.26-16.08,11.35-21.41,12.51-19.35,4.2-33.76,15.62-45.65,26.15-5.72,5.06-20.06,64.24-27.36,74.31,4.49,1.54,16.62,4.45,21.38,4.66,2.66-9.26,20.16-49.13,21.67-60.19.43-3.13,5.25-6.13,8.44-7.77,14.17-7.28,18.96-14.19,32.95-15.26,2.97-.23,6.05-.48,8.66-1.89,6.42-3.47,7.07-11.45,5.65-17.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m458.98,241.8c-.77-3.99.62-12.07-4.39-12.47-3.99-.31-24.98-8.74-25.3-3.84-.21,3.08-1.72,7.96,3.26,13.24-25.07,2.85-33.47,14.43-45.72,24.57-5.85,4.84,2.98,68.36.63,75.63,4.32,1.89,15.22.88,19.93,1.28,1.1-22.84,3.02-40.29,1.04-52.14-1.87-11.12-3.93-14.62-.68-16.16,14.41-6.82,22.26-10.39,36.28-11.01,2.98-.13,6.07-.29,8.72-1.61,6.53-3.26,7.46-11.22,6.25-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m423.05,225.69c-3.54-13.91-4.06-38.95-4.52-45.83-.44-6.61-.6-13.8,5.49-17.29,6.97-3.97,24.68-4.45,31.73-2.14,5.61,1.84,11.37,3.88,12.57,8.69,1.1,4.44,1.14,12.25-.5,16.53-16.04,41.95-11.06,40.47-13.47,50.37-.25,1.05-29.82-4.52-31.29-10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m475.1,182.46c-2.6,12.34-13.14,27.53-10.47,37.99,3.65,14.28-1.94,33.24-4.08,36.86-1.41,0-2.68-.28-3.85-.78-8.68-3.71-11.4-19.49-23.48-20.98,10.57-8.68-1.15-43.41,20.93-76.5,14.95,4.29,16.54,5.42,20.15,12.39,1.64,3.18,1.65,6.94.8,11.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m438.27,173.65l-3.02-.32s-11.52,40.89-9.78,51.11l3.77,5.09,5.24-5.6s1.24-40.21,3.79-50.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m441.65,167.55l-3.38,6.09-3.02-.32s-.14-6.5.34-6.25c.48.24,6.06.47,6.06.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m417.4,174.57c1.37-6.42-1.07-10.47,13.18-14.78,1.12-.34,3.07-.2,4.28-.31-7.65,10.51-11.63,42.41-7.62,72.25-5.8-2.15-8.3.04-9.87-.91-.46-7.19,1.46-7.1,2.19-11.54,2.3-14.11-6.11-26.17-2.16-44.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m424.77,168.24c.37.31,1.79.75,2.16,1.06-1.75,0-3.04.52-4.1.58-.98,7.57-.14,25.08,2.75,35.03,1.35-17.96,1.53-18.73,2.35-23.62.16-.97,2.81-13.76,3.94-16.16,1.67-3.53,2.2-4.26,3-5.65-2.84-1.86-8.72,7.22-10.1,8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m464.63,220.44c3.65,14.28-1.94,33.24-4.08,36.86-1.41,0-2.68-.28-3.85-.78-.65-1.88,8.07-22.65-6.04-34.29-2.32-1.92-4.53-5.27-2.62-8.28,2.24-3.53,4.12-6.95,5.61-10.83,2.01-5.25,2.55-11.04,3.52-16.55.45-2.59.83-5.34,1.88-7.77.57-1.3,2.26-4.53,3.83-4.28-.65-2.09,6.12,2.04,7.15,2.78,1.91,1.38,3.61,3.15,5.07,5.15-2.6,12.34-13.14,27.53-10.47,37.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m464.95,264.29c-.27,0-.54-.06-.79-.19-.86-.44-1.2-1.49-.76-2.35l14.94-29.22c.42-.82.48-1.67.15-2.21-.41-.66-1.47-1.03-3-1.03h-46.03c-1.73,0-2.96.33-3.28.87-.65,1.1.98,4.09,1.67,5.36l14.28,26.18c.46.85.15,1.91-.7,2.37-.85.46-1.91.15-2.37-.7l-14.25-26.13c-1.25-2.29-3.3-6.06-1.64-8.86,1.02-1.71,3.13-2.58,6.28-2.58h46.03c3.58,0,5.23,1.47,5.98,2.7.97,1.59.96,3.69-.02,5.62l-14.94,29.22c-.31.6-.92.95-1.56.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 429.23,
    y: 224.94,
    width: 51.83,
    height: 2.4,
    rx: 1.13,
    ry: 1.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m452.53,156.12c1.54,3.15-9.3,10.32-15,9.94-2.34-.16-3.48-7.17-3.28-7.53.52-.97.35-2.78-.17-7.91-.29-2.85,3.35-3.8,8.41-5.97,3.13-1.35,10.11-3.46,9.52-1.3-1.43,5.19-.9,9.87.52,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m446.31,148.88c-1.3,1.84-10.74,5.76-12.06,6.05-2.23.49-2.28-.13-4.79-.2-1.49-.03-1.72-5.42-2.48-9.27-.95-4.74-.25-8.04-.01-12.62.15-2.82.81-4.89,1.95-6.49.62-.88,1.38-1.61,2.28-2.25.69-.49,1.61-.9,2.66-1.22,5.75-1.75,15.66-.84,16.72,3.56.9,3.73-2.12,19.4-4.27,22.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m446.59,128.3c-1.02-.97-1.96-1.72-3.49-1.73-4-.05-7.87,2.54-11.96,1.33-.93-.27-1.86-.74-2.23-1.56.62-.88,1.38-1.61,2.28-2.25.69-.49,1.61-.9,2.66-1.22.61-.1,1.23-.19,1.84-.23,2.64-.17,6.02-.3,8.51.68,1.62.63,3.53,3.28,2.39,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m429.98,122.74c.54-.88,5.74-3.24,6.77-3.47.67-.15,20.21-3.63,20.15,11.39-.03,7.77-6.38,19.51-6.18,18.36,1.91-10.56-.64-9.31-3.07-7.82,1.43-6.36-.8-16.97-4.9-15.75-7.24,2.16-14.87.7-12.77-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m453.73,122.4c-.68,1.58-1.75,2.98-3.15,4.03-1.35,1.01-2.78,1.53-4.12,1.76,1.54,3.37,2.08,9.02,1.19,13.01,2.44-1.49,4.99-2.75,3.07,7.82-.21,1.15,6.14-10.59,6.18-18.36.02-3.85-1.26-6.47-3.17-8.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m448.09,140.4c-1.5,2.19-1.6,4.69-.22,5.59,1.38.9,3.7-.15,5.2-2.34,1.5-2.19,1.6-4.69.22-5.59-1.38-.9-3.7.15-5.2,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m433.38,144.89c5.68.18,3.42,5.19,5.25,4.8,4.99-1.06,9.28-9.8,9.92-11.13-.96,5.17-1.42,9.27-2.72,11.28-2,3.1-10.74,6.04-12.05,6.32-2.23.49-2.28-.13-4.79-.19-1.41-.04-3.61-9.94-2.43-10.8.65-2.01,4.99-.34,6.82-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m430.93,151.71c1.35.05,3.27,2.03,4.24-4.38-.54-.04-.19-.02-.97-.12-1.93-.26-4.25-.67-5.25-.88-.25-.05-.43-.09-.48-.12-.11,5.25.76,5.43,2.46,5.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m449.86,166.67c-2.03,2.42-4.06,4.84-6.09,7.26.13-.15-3.34-4.32-5.06-6.42-3.33,1.02-4.68,2.9-7.3,5.05-.65-4.28.82-9.52,3.01-13.34.44-.29.44.67.44,1.42,0,3.22,1.34,3.43,3.68,6.23,1.2-.15,4.23-1.55,6.1-2.99,1.34-1.03,5.73-4.81,7.4-6.82.96-1.15-.02,1.7,2.05,2.95-.39,1.19-3.17,5.37-4.25,6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m449.86,165.5c-2.03,2.42-4.06,4.84-6.09,7.26.13-.15-3.34-4.32-5.06-6.42-3.33,1.02-4.68,2.9-7.3,5.05-.65-4.28.82-9.52,3.01-13.34.44-.29.44.67.44,1.42,0,3.22,1.34,3.43,3.68,6.23,1.2-.15,4.23-1.55,6.1-2.99,1.34-1.03,5.73-4.81,7.4-6.82.96-1.15-.02,1.7,2.05,2.95-.39,1.19-3.17,5.37-4.25,6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m456.64,159.77c0,.27-2.69,7.43-2.76,10.69-1.14.29-1.98-.02-2.92.38,1.07.6,2.51.94,3.72,1.52-2.65,3.45-10.36,18.18-15.39,35.03-.46-1.57,1.93-32.68,13.23-47.92.54-.73.05-2.44,1.07-1.93.85.42,3.05,1.38,3.05,2.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m431.62,219.16c-1.02-.16-4.61,2.08-6.08,2.6-3.05,1.07-5.43,2.23-7.6,4.59-1.04,1.13-5.43,11.47-3.42,11.83,1.89.34,2-5.48,2.12-6.4-.25,1.1-.95,8.63.18,8.89,1.88.45,1.52-7.3,1.43-8.1-.06,1.13-.41,7.2.52,7.89,2.26,1.65,1.69-6.85,1.9-7.51-.11,1.59-.21,7.18,1.55,6.88.98-.11.77-2.8.73-4.46-.05-2.29.21-4.54,2.25-5.46,2.6-1.17,5-.76,7.14-2.89,1.19-1.19,1.22-1.16,3.08-1.67,1.34-.37,2.22-.49,2.19-2.01-.03-1.23-1.88-4.25-3.14-4.61-1.03-.3-2.72.29-2.86.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m434.48,218.74c-1.03-.3-2.72.29-2.86.42-.41-.06-1.22.26-2.15.7.74.92,1.71,2.49,1.49,4.34-.35,2.92-6.14,2.2-8.15,5.45-.79,1.29-1.2,3.41.19,7.1,0-.49-.03-.96-.04-1.38-.05-2.29.21-4.54,2.25-5.46,2.6-1.17,5-.76,7.14-2.89,1.19-1.19,1.22-1.16,3.08-1.67,1.34-.37,2.22-.49,2.19-2.01-.03-1.23-1.88-4.25-3.14-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m429.32,219.18s4.45,5.32,3.97,7.18l3.37.55-2.42-8.59-4.93.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m477.11,223.42c-10.54,4.38-36.05,4.38-42.24,4.2.87-2.43-.37-6.48-2.18-10.07,3.59-.72,19.76-4.53,26.96-5.78,1.44-.25,2.53-.4,3.08-.4.08-.85.07-1.72-.01-2.65h0c-.45-5.41-3.12-12.59-2.46-27.13.27-6.07,2.69-15.69,10.41-15.27,4.02.22,6.17,7.01,6.7,14.92.95,13.96,1.72,41.36-.27,42.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m466.95,214.59c-.62.09-1.3-.54-1.79-.86-.91-.62-1.78-1.07-2.86-1.33-.9-.22-1.79-.34-2.64-.64,1.44-.25,2.53-.4,3.08-.4.08-.85.07-1.72-.01-2.65.22.65.49,1.29.79,1.87.4.79.88,1.49,1.49,2.12.46.48,1.82,1.23,1.94,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m418.26,232.58c-.04.72-.19,3.42-.06,5.48.26-2.19.12-5.01.06-5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m416.29,235.22c.24-1.46.3-3,.36-3.44-.1.43-.26,1.85-.36,3.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m412.98,210.53c-.63.05-1.27-.61-1.73-.97-.87-.67-1.71-1.18-2.78-1.5-.88-.27-1.83-.6-2.66-.95,1.6-.22,2.61-.14,3.16-.1.06-.8.15-1.4.29-2.63.18.66.28,1.34.54,1.94.35.81.79,1.54,1.36,2.21.43.51,1.74,1.34,1.82,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m353.4,225.09c-1.37.45-2.8.25-3.5.1.01.06.04.13.08.19,1.2,1.83,6.05-.71,9.43-1.21,3.89-.57,6.29.44,6.29.44,0,0-3.13-2.03-4.92-1.95-1.79.08-5.48,1.81-7.37,2.43Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m363.42,151.12l13.08.08,17.37,12.94-6.36-13,14.58.18c1.9.02,3.45-1.5,3.46-3.4l.15-24.15c.01-1.89-1.51-3.43-3.4-3.44l-38.7-.23c-1.89-.01-3.43,1.51-3.44,3.4l-.15,24.17c-.01,1.89,1.51,3.43,3.4,3.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m392.41,135.65c0-.48-.14-.89-.43-1.21-.29-.32-.72-.48-1.29-.48s-1.01.16-1.31.48c-.3.32-.45.72-.45,1.21s.15.85.45,1.16c.3.31.73.47,1.31.47s1-.16,1.29-.47c.29-.31.43-.7.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m384.28,135.65c0-.48-.14-.89-.43-1.21-.29-.32-.72-.48-1.29-.48s-1.01.16-1.31.48c-.3.32-.45.72-.45,1.21s.15.85.45,1.16c.3.31.73.47,1.31.47s1-.16,1.29-.47c.29-.31.43-.7.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m376.5,135.65c0-.48-.14-.89-.43-1.21-.29-.32-.72-.48-1.29-.48s-1.01.16-1.31.48c-.3.32-.45.72-.45,1.21s.15.85.45,1.16c.3.31.73.47,1.31.47s1-.16,1.29-.47c.29-.31.43-.7.43-1.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 307.21,
    y: 241.18,
    width: 20,
    height: 117.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m508.78,239.76c0,8.16-84.84,14.77-189.49,14.77s-189.49-6.61-189.49-14.77,84.84-14.77,189.49-14.77c94.84,0,175.59,3.24,189.49,10.33v4.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 319.29,
    cy: 235.33,
    rx: 189.49,
    ry: 14.77
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m350.53,237.05l-44.07-.35c-.59,0-.99-.62-.74-1.16l12.75-27.59c.13-.29.43-.48.75-.47l44.07.35c.59,0,.99.62.74,1.16l-12.75,27.59c-.13.29-.43.48-.75.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "349.3 235.02 308.32 234.7 319.79 209.87 360.77 210.19 349.3 235.02"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "349.3 235.02 308.32 234.7 313.68 234.74 344.24 210.06 360.77 210.19 349.3 235.02"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "305.72 235.54 281.59 238.73 281.5 241.32 336.07 243.82 351.08 238.52 351.28 236.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m234.57,161.29c-.12,6.01-5.39.94-5.5-1.06-.11-1.99.55-3.52,1.97-3.58,1.42-.06,3.57,2.64,3.53,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m256.9,157.34c-.9,6-2.41,9.98-5.93,17.02-.01.02-.03.05-.07.06-.58.32-4.25,0-4.66-.23-10.28-5.91-10.14-7.57-10.71-11.35-.13-.91-.31-1.93-.68-3.17-1.28-4.29-2.11-11.66.43-15.12,1.28-1.75,3.33-3.13,5.7-3.13,1.05.09,6.04-.57,10.3,2.17,4.26,2.73,6.67,6.73,5.63,13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m250.9,174.48c-.58.18-4.25,0-4.66-.13-10.28-3.36-10.14-4.31-10.71-6.46.26-.09,10.43-8.56,15.72-9.67,2.48-.52,1.67,4.97,1.61,5.12-3.28,8.21-1.63,10.69-1.96,11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m252.46,161.29c.12,6.01,5.39.94,5.5-1.06.11-1.99-.55-3.52-1.97-3.58-1.42-.06-3.57,2.64-3.53,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m230.02,179.92c3.6-1.19,5.73-5.17,21.8,1.09-1.74-2.76-1.97-10.37-1.52-16.55.25-3.43-1.49,2.01-7.21-.46-3.55-1.53-10.25-2.65-9.85-.02,1.39,9.16-1.13,12.1-3.22,15.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m259.6,144.42c.28-1.24.16-2.35-.24-3.35-1.6-4-7.74-6.18-11.66-7.19-11.47-2.96-17.45,1.83-19.63,8.74-.04.05-.08.09-.12.14-6.45,6.91,1.23,15.13,4,19.11,1.25,1.79,2.22,6.84,3.38,8.11,1.52.43,6.83-.09,10.58.8,3.34-4.69,4.22-5.58,9.23-13.05.72-1.08,8.54-7.06,4.46-13.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m259.7,144.59c-1.42,6.37-6.56,13.91-14.31,16.3-6.55,2.02-16.54-6.27-19.54-14.71-2,6.03,3.77,12.35,6.09,15.68,1.25,1.79,2.22,6.84,3.38,8.11,1.52.43,6.83-.09,10.58.8,3.34-4.69,4.22-5.58,9.23-13.05.72-1.07,8.39-6.94,4.57-13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m231.86,165.97c.03.12.04.24-.19.58.02-.19.08-.39.19-.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m276.61,282.78c1.35,3.78.63,8.82,1.21,12.92.99,6.94,2.46,13.94,4.1,20.77,1.74,7.26,4.14,14.21,6.27,21.35.65,2.18.77,4.1,2.42,8.62-4.56,6.15-15.44,10.2-19.73,8.7-6.53-12.98-10.34-26.25-15.27-42.69-2.91-9.73-6.23-34.32,7.49-37.01,10.16-1.99,15,7.1,14.6,15.76l-1.09-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m226.92,179.95c.27-.05,4.14-4.8,9.57-5.19,5.44-.39,18.71,2.44,20.65,5.15l-30.23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m214.64,267.98c-2.71,4.02.18,12,2.3,15.79,3.48,6.21,8.14,9.59,13.82,9.67,12.87.18,16.39-.09,31.38-2.01,9.55-1.22,16.36,1.79,31.18,1.18-.17,10.7,10.17,28.13,14.19,37.84,3.35,8.09,8.71,14.62,10.97,22.8,5.95.99,8.51.62,19.11-6.04-3.42-12.31-7.41-25.05-11.45-37.33-3.39-10.31-11.01-28.6-13.11-33.86-1.57-3.95-23.84-11.89-35.67-13.36-14.71-1.83-16.57-1.57-24.45-2.63l-38.27,7.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m214.77,271.86c-3.93-5.95.93-18.2.03-24.94-2.15-16.13-5.54-38.35-5.18-46.1.35-7.44-.09-9.65,5.12-15.42,8.02-8.9,39.13-7.44,46.92-4.27,7.8,3.18,9.31,4.76,10.02,10.33.66,5.15-1.2,16.69-3.54,21.16-16.69,31.88-11.99,34.35-10.2,41.69.34,1.42,9.18,6.35,6.62,8.06-1.16.78-42.17,21.04-49.79,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m294.65,236.07c1.29-1.45,4.31-1.63,4.31-1.63,0,0,2.38,9.61.87,10.87-1.51,1.26-4.28-.22-4.28-.22l-.91-9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m270.92,206.25c-1.94,6.37-7.04,17.92-7.9,25.9,1.89.21,29.24.16,33.99,1.06.16,3.32,2.66,6.82,1.32,13.36-8.33.17-32.33,1.89-42.96.87-5.27-.5-10.07-2.18-10.88-7.71-1.76-12.08-1.42-26.41,3.28-37.44,3.67-8.62,11.25-21.4,20.52-18.08,11.66,4.17,4.62,15.48,2.62,22.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m249.99,300.56c-7.72,0-13.98-3.56-13.98-7.96h27.96c0,4.39-6.26,7.96-13.98,7.96Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m266.79,292.6l-60.54-.3s-11.77-2.85-14.81-9.18c-4.01-8.36-6.02-42.98-14.57-73.59h50.86c8.55,30.6,10.56,65.22,14.57,73.59,3.04,6.32,14.81,9.18,14.81,9.18l50.4.25-40.72.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m266.79,294.35h-.01l-60.54-.3c-.14,0-.27-.02-.4-.05-.51-.12-12.61-3.13-15.97-10.12-1.95-4.05-3.31-13.04-5.21-25.47-2.16-14.2-4.85-31.87-9.47-48.4-.15-.53-.04-1.09.29-1.53.33-.43.84-.69,1.39-.69h50.86c.78,0,1.47.52,1.68,1.28,4.68,16.74,7.39,34.52,9.56,48.81,1.78,11.68,3.18,20.91,4.9,24.49,2.15,4.48,10.25,7.38,13.45,8.19l50.19.25c.96,0,1.74.79,1.74,1.75,0,.96-.78,1.74-1.74,1.74l-40.72.05Zm-60.33-3.79l41.8.2c-3.05-1.62-6.1-3.88-7.54-6.88-1.95-4.05-3.31-13.04-5.21-25.47-2.11-13.83-4.72-30.96-9.12-47.12h-47.25c4.31,16.08,6.88,32.93,8.96,46.6,1.78,11.68,3.19,20.91,4.9,24.49,2.15,4.47,10.25,7.37,13.45,8.19Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m258.04,294.25c-.63,0-1.25-.35-1.56-.95l-15.15-29.63c-1-1.95-1-4.07-.02-5.67.76-1.24,2.43-2.72,6.04-2.72h46.68c3.19,0,5.32.88,6.35,2.6,1.68,2.83-.39,6.64-1.63,8.92l-14.48,26.55c-.46.85-1.52,1.16-2.37.7-.85-.46-1.16-1.52-.7-2.37l14.45-26.5c.73-1.35,2.39-4.39,1.72-5.51-.33-.56-1.58-.9-3.35-.9h-46.68c-1.56,0-2.65.37-3.06,1.06-.34.55-.28,1.42.15,2.26l15.15,29.63c.44.86.1,1.91-.76,2.35-.25.13-.53.19-.79.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 245.91,
    y: 254.65,
    width: 49.86,
    height: 2.36,
    rx: 1.11,
    ry: 1.11,
    transform: "translate(541.69 511.66) rotate(180)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m299.15,235.39l10.44-4.06s5.51,5.12,5.8,7.44c.29,2.32-1.93,4.83-3.29,4.83s-12.08.29-12.08.29c0,0-.39-7.35-.87-8.51Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGuestCampaignImage);
export default __webpack_public_path__ + "static/media/share-guest-campaign_image.000944d0b141f41487ec0576d99ce57b.svg";
export { ForwardRef as ReactComponent };